import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "@components";
import { useAdminProductReviewTable } from "../../../../@hooks";


export default function EditButton({ rowData }) {

    const { rowEditClicked, handleEditRowClick, rowIsLoading } = useAdminProductReviewTable(rowData)

	const isOpenFormClass = rowEditClicked ? 'is-open' : ''
	const isLoadingClass = rowIsLoading ? 'is-loading' : ''

    return <Box componet="span" className={`${isOpenFormClass} ${isLoadingClass}`} >
        <ActionButton
            label="Edit"
            icon="pen-to-square"
            color="info"
            onClick={handleEditRowClick}
        />
    </Box>
}